export default __webpack_public_path__ + "static/media/renegotiation.20fbe61a.png";